<template>
  <div>
    <div class="search d-flex align-items-center">
      <div class="w search-box d-flex align-items-center">
        <div class="logo d-flex align-items-center">
          <router-link to="/" :title="common_info.store.name"
            ><img
              class="img-default search-img"
              :src="common_info.store.logo"
              :alt="common_info.store.name"
          /></router-link>
          <div class="shop" v-if="mch && mch.id">
            <div class="shop-details">
              <router-link
                :to="{ path: '/shop', query: { mch_id: mch.id } }"
                class="shop-name show-one-lines"
                v-text="mch.name"
              ></router-link>
              <div class="certification" @click="handleCertification()">
                查看资质
              </div>
            </div>
            <!-- <div class="shop-name show-one-lines" v-text="mch.name"></div> -->
            <div class="d-flex align-items-center">
              <span
                class="show-one-lines shop-info"
                v-if="mch.address"
                :title="'地址：' + mch.address"
                >店铺信息</span
              >
              <span
                class="show-one-lines shop-info"
                v-text="'评分：' + mch.score"
                v-if="!mch.address && mch.score"
              ></span>
              <div
                class="d-flex align-items-center customer_service"
                @click="webService('mch')"
                v-if="customer_service"
              >
                <img
                  class="img-default shop-img"
                  src="../../assets/images/service.png"
                  alt
                />
                <span>在线客服</span>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="shop">
              <div class="shop-details">
                <p class="shop-name show-one-lines">平台自营</p>
                <!-- <div class="certification" @click="handleCertification()">
                  查看资质
                </div> -->
              </div>
              <div class="d-flex align-items-center">
                <!-- <span
                  class="show-one-lines shop-info"
                  v-if="store.contact_tel"
                  :title="'电话：' + store.contact_tel"
                  >店铺信息</span
                > -->
                <template v-if="store.option">
                  <div
                    class="d-flex align-items-center customer_service"
                    @click="webService()"
                    v-if="
                      store.option &&
                      store.option.web_service_status == 1 &&
                      store.option.web_service_url
                    "
                  >
                    <img
                      class="img-default shop-img"
                      src="../../assets/images/service.png"
                      alt
                    />
                    <span>在线客服</span>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="search-c">
          <div class="search-item">
            <div class="box">
              <img
                class="img-default img"
                src="../../assets/images/search.png"
                alt
              />
              <input
                placeholder="搜索商品"
                class="search-input"
                type="text"
                v-model="searchtext"
                ref="searchtext"
              />
            </div>
            <div class="search-btn" @click="searchshop()">搜索</div>
            <div class="search-btn2" v-if="mch && mch.id && false">搜本店</div>
          </div>
        </div>
        <!-- <div class="cat" @click="cartgoto()">
					<img class="img-default xia" src="../../assets/images/cat.svg" alt /> 我的购物车
					<span v-text="carnum"></span>
				</div> -->
        <div class="code_wrap">
          <ul class="code">
            <li class="code-item code-item1">
              <div class="code-img">
                <img src="../../assets/images/app_store.png" alt="" />
              </div>
              <div
                class="code-name smallsize-font"
                :class="isChrome ? 'chrome' : ''"
              >
                APP商城
              </div>
              <img
                class="code-activity"
                src="../../assets/images/new_register.png"
                alt=""
              />
              <div class="big-code1">
                <img class="bg" src="../../assets/images/bg.png" alt="" />
                <img
                  class="code"
                  src="../../assets/images/app_store.png"
                  alt=""
                />
              </div>
            </li>
            <li class="code-item code-item2">
              <div class="code-img">
                <img src="../../assets/images/mini_store.jpg" alt="" />
              </div>
              <div
                class="code-name smallsize-font"
                :class="isChrome ? 'chrome' : ''"
              >
                小程序商城
              </div>
              <img
                class="code-activity"
                src="../../assets/images/new_register.png"
                alt=""
              />
              <div class="big-code2">
                <img class="bg" src="../../assets/images/bg.png" alt="" />
                <img
                  class="code"
                  src="../../assets/images/mini_store.jpg"
                  alt=""
                />
              </div>
            </li>
            <li class="code-item code-item3">
              <div class="code-img">
                <img src="../../assets/images/xz_public.png" alt="" />
              </div>
              <div
                class="code-name smallsize-font"
                :class="isChrome ? 'chrome' : ''"
              >
                修正健康公众号
              </div>
              <img
                class="code-activity3"
                src="../../assets/images/more_activity.png"
                alt=""
              />
              <div class="big-code3">
                <img class="bg" src="../../assets/images/bg.png" alt="" />
                <img
                  class="code"
                  src="../../assets/images/xz_public.png"
                  alt=""
                />
              </div>
            </li>
            <li>
              <div
                class="code-item code-item4"
                @mouseenter="show = true"
                @mouseleave="show = false"
              >
                <div class="code-img">
                  <img
                    src="../../assets/images/xz_certificate_icon.png"
                    alt=""
                  />
                </div>
                <div
                  class="code-name smallsize-font"
                  :class="isChrome ? 'chrome' : ''"
                >
                  资质证书
                </div>
                <img
                  class="btn"
                  src="../../assets/images/certificate_btn.png"
                  alt=""
                />
              </div>
              <div
                class="certificate"
                v-show="show"
                :style="{ opacity: show ? '1' : '0' }"
              >
                <img src="../../assets/images/xz_certificate2.jpg" alt="" />
                <img src="../../assets/images/xz_certificate1.png" alt="" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog
      title="店铺资质"
      :visible.sync="showCertification"
      class="certification-box"
      custom-class="my-custom-dialog"
    >
      <el-dialog title="" :visible.sync="preview.show" append-to-body>
        <img :src="preview.url" alt="" class="main-img" />
      </el-dialog>
      <div class="content">
        <div class="left">
          <div
            class="name"
            :class="index == certificationIndex ? 'active' : ''"
            v-for="(item, index) in certificationData"
            :key="index"
            @click="handleSelctCertification(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="right">
          <img
            :src="certificationData[certificationIndex]?.img"
            alt=""
            @click="handlePreview(certificationData[certificationIndex]?.img)"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";

export default {
  props: {
    mch: {
      type: Object,
      default() {
        return {};
      },
    },
    customer_service: {
      type: String,
      default() {
        return "";
      },
    },
    store: {
      type: Object,
      default() {
        return {};
      },
    },
    goods: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      login: true,
      common_info: {
        store: {},
      },
      searchtext: "", //搜索商品
      carnum: 0, //购物车数量
      isChrome: false,
      show: false, //展示证书
      showCertification: false, //店铺资质
      preview: {
        //预览图片
        show: false,
        url: "",
      },
      certificationData: [], //店铺资质
      certificationIndex: 0, //选中的店铺资质
    };
  },
  created() {
    let that = this;
    this.common.loginType(this);
    this.common.getCommonInfo(this);
    if (!this.login) {
      this.cartnumapi();
    }
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key === 13) {
        if (that.$refs.searchtext.value) {
          that.searchshop();
        }
      }
    };
    var userAgent = navigator.userAgent;
    console.log(userAgent);
    if (/chrome/i.test(userAgent)) {
      this.isChrome = true;
    }
  },
  methods: {
    // 选择资质图片
    handleSelctCertification(index) {
      this.certificationIndex = index;
    },
    // 预览图片
    handlePreview(url) {
      this.preview.show = !this.preview.show;
      if (url) {
        this.preview.url = url;
      }
    },
    // 是否展示店铺资质
    handleCertification() {
      this.showCertification = !this.showCertification;
      this.certificationData = [];
      this.certificationIndex = 0;

      if (this.showCertification) {
        const loadingInstance = Loading.service({
          target: ".my-custom-dialog", // 指定目标为弹窗的自定义类名
          lock: true,
          text: "",
          background: "rgba(255, 255, 255, 0.8)",
        });
        let params = {
          mch_id: this?.mch?.id,
        };
        try {
          this.$api
            .introduce(params)
            .then((res) => {
              this.certificationData = res.data.business_license;
            })
            .catch((err) => {
              console.log(err);
            });
        } catch (error) {
        } finally {
          loadingInstance.close();
        }
      }
    },
    // 购物车数量
    cartnumapi() {
      if (this.$store.state.user) {
        if (this.$store.state.user.token != "") {
          this.$api
            .cartnum()
            .then((res) => {
              this.carnum = res.data;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    cartgoto() {
      this.$router.push("/cat");
    },
    // 搜索商品
    searchshop() {
      let searchname = this.$refs.searchtext.value;
      if (searchname == "") {
        this.$message({
          showClose: true,
          message: "搜索商品不可为空",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
      } else {
        let parms = {
          keyword: searchname,
        };
        if (this.catid) {
          parms.id = this.catid;
        }
        this.$router.push({
          path: "/list",
          query: parms,
        });
      }
    },
    // 客服
    webService(type) {
      let goods = this.goods;
      let store = this.store;
      let customer_service = this.customer_service;
      if (this.$store.state.user) {
        if (this.$store.state.user.token != "") {
          let url_str = this.common.webService(
            this,
            goods,
            store,
            type,
            customer_service,
          );
          window.open(url_str);
        } else {
          this.$router.push({
            name: "signin",
            query: {
              redirect: this.$router.currentRoute.fullPath,
            },
          });
        }
      } else {
        this.$router.push({
          name: "signin",
          query: {
            redirect: this.$router.currentRoute.fullPath,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  height: 112px;
  background-color: #fff;
  width: 100%;

  .search-box {
    display: flex;
    height: 112px;
    // padding-top: 32px;
    box-sizing: border-box;

    .logo {
      > a {
        display: block;
        width: 187px;
        height: 55px;
        margin-right: 44px;
      }

      .logo-img {
        width: 187px;
        height: 55px;
        object-fit: contain;
        display: block;
      }

      .search-img {
        width: auto;
        height: auto;
        object-fit: fill;
        display: block;
        margin: 0 auto;
        max-width: 100%;
        max-height: 100%;
      }

      .shop {
        // width: 140px;
        position: relative;

        &::after {
          content: "";
          width: 1px;
          height: 55px;
          background: #ebebeb;
          position: absolute;
          top: -5px;
          left: -21px;
        }

        .shop-details {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .shop-name {
            max-width: 140px;
            font-size: 14px;
            color: #666666;
            font-weight: 500;
            display: block;
            margin-right: 5px;
          }
          .certification {
            border-radius: 4px;
            background-color: rgba(64, 149, 229, 1);
            color: rgba(255, 255, 255, 1);
            font-size: 12px;
            padding: 2px 4px;
            cursor: pointer;
          }
        }

        span {
          color: #999999;
        }

        .shop-info {
          margin-right: 12px;
        }

        .shop-img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
      }
    }

    .search-c {
      margin-left: auto;

      .search-item {
        display: flex;

        .box {
          width: 310px;
          height: 36px;
          border: 2px solid #ff0008;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          .img {
            height: 10px;
            width: 10px;
            margin-left: 10px;
            margin-right: 4px;
          }

          .search-input {
            width: 100%;
            height: 32px;
            // border: 0 none;
            // box-sizing: border-box;
          }
        }

        .search-btn {
          width: 90px;
          height: 36px;
          background-color: #ff0008;
          color: #fff;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }

        .search-btn2 {
          width: 90px;
          height: 36px;
          background-color: #ff9010;
          color: #fff;
          font-size: 18px;
          margin-left: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      // .search-default {
      //   display: flex;
      //   margin-top: 8px;
      //   color: #b3b3b3;
      //   li {
      //     margin-right: 8px;
      //   }
      // }
    }

    .cat {
      height: 40px;
      width: 120px;
      border: 1px solid #ff0008;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ff0008;
      box-sizing: border-box;
      margin-left: 32px;
      cursor: pointer;
      border-radius: 2px;
      position: relative;

      span {
        position: absolute;
        top: 3px;
        left: 23px;
        right: auto;
        display: inline-block;
        padding: 1px 3px;
        font-size: 12px;
        line-height: 12px;
        color: #fff;
        background-color: #e1251b;
        border-radius: 7px;
        min-width: 12px;
        text-align: center;
      }

      .xia {
        height: 18px;
        width: 18px;
        margin-right: 12px;
      }
    }
    .code_wrap {
      width: 214px;
      padding-left: 38px;

      .code {
        display: flex;
        .code-item {
          width: 54px;
          margin-left: 14px;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          position: relative;
          .code-img {
            width: 36px;
            height: 36px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .code-name {
            width: 84px;
            font-size: 12px;
            // -webkit-transform: scale(0.8);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 13px;
            text-align: center;
            margin-top: 4px;
            margin-bottom: 2px;
          }

          .smallsize-font {
            font-size: 12 * 0.8px;
          }
          .chrome {
            transform: scale(0.8);
          }
          .code-activity {
            width: 54px;
            height: 16px;
          }
          .code_activity3 {
            width: 64px;
            height: 16px;
          }
          .big-code1,
          .big-code2,
          .big-code3 {
            position: absolute;
            bottom: -138px;
            left: 50%;
            transform: translateX(-50%);
            width: 138px;
            height: 138px;
            z-index: 98;
            opacity: 0;
            .bg {
              width: 100%;
              height: 100%;
            }
            .code {
              width: 130px;
              height: 130px;
              position: absolute;
              top: 4px;
              left: 4px;
            }
          }
        }
        .certificate {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          // width: 873px;
          // height: 320px;
          width: 50%;
          height: 50%;
          z-index: 999999;
          display: flex;
        }
        .certificate img {
          margin: 0 10px;
        }
        .code-item3 {
          width: 64px;
        }

        .code-item1:hover .big-code1 {
          opacity: 1;
          z-index: 98;
        }
        .code-item2:hover .big-code2 {
          opacity: 1;
          z-index: 98;
        }
        .code-item3:hover .big-code3 {
          opacity: 1;
          z-index: 98;
        }
      }
    }
  }
}

.customer_service {
  cursor: pointer;
}
.certification-box {
  height: 100vh;
  overflow: hidden;
  ::v-deep .el-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 80vh;
    margin: 0 !important;
    border-radius: 10px;

    .el-dialog__header {
      position: relative;
      height: 35px;
      border-bottom: 1px solid #e5ebf3;
      padding: 20px 0 10px;
      margin: 0 20px;

      .el-dialog__title {
        font-weight: 500;
        font-size: 16px;
        color: #3d3d3d;
      }

      .el-dialog__headerbtn {
        right: 0;
      }
    }
    .el-dialog__body {
      height: calc(100% - 66px);
      padding: 20px;
      box-sizing: border-box;
    }
  }

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    .left {
      width: 22%;
      margin-right: 3%;
      overflow-y: auto;
      .name {
        width: 100%;
        height: 50px;
        padding: 15px 20px;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        margin-bottom: 14px;
        white-space: nowrap;
        overflow: hidden;
        display: block;
        text-overflow: ellipsis;
        cursor: pointer;
      }

      .active {
        background: linear-gradient(90deg, #ff9010 0%, #ff1025 100%);
        border-radius: 6px 6px 6px 6px;
        color: #ffffff;
      }
    }
    .right {
      flex: 1;
      height: 100%;
      img {
        // max-width: 100%;
        max-height: 100%;
        width: auto;
        // height: auto;
        /* 可选：让图片居中 */
        display: block;
        margin: 0 auto;
        cursor: pointer;
      }
    }
  }
}
.main-img {
  width: 100%;
  margin: auto;
}
</style>
